(() => {
  const init = (scope = document) => {
    const collect = selector => scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    collect('[data-meclean-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const cards = [...catalog.querySelectorAll('[data-meclean-machine]')];
      const search = catalog.querySelector('[data-machine-search-input]');
      const category = catalog.querySelector('[data-machine-category]');
      const reset = catalog.querySelector('[data-machine-reset]');
      const more = catalog.querySelector('[data-machine-more]');
      const status = catalog.querySelector('[data-machine-results]');
      const empty = catalog.querySelector('[data-machine-empty]');
      const filterPanel = catalog.querySelector('[data-machine-filter-panel]');
      if (filterPanel) {
        const mobile = matchMedia('(max-width: 600px)');
        filterPanel.open = !mobile.matches;
        filterPanel.hidden = false;
        mobile.addEventListener('change', event => { filterPanel.open = !event.matches; });
      }
      let limit = 24;
      const filter = () => {
        const terms = (search?.value || '').toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        const group = category?.value || '';
        const matches = cards.filter(card => (!group || card.dataset.group === group) && terms.every(term => card.dataset.machineSearch.toLocaleLowerCase().includes(term)));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        status.textContent = `${Math.min(limit, matches.length)} of ${matches.length} machines shown`;
        empty.hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
      };
      search?.addEventListener('input', () => { limit = 24; filter(); });
      category?.addEventListener('change', () => { limit = 24; filter(); });
      reset?.addEventListener('click', () => { if (search) search.value = ''; if (category) category.value = ''; limit = 24; filter(); search?.focus(); });
      more.addEventListener('click', () => { limit += 24; filter(); });
      catalog.querySelector('[data-machine-controls]').hidden = false;
      filter();
    });
    collect('[data-machine-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const thumbnails = [...gallery.querySelectorAll('[data-machine-thumbnail]')];
      const main = gallery.querySelector('[data-machine-main-image]');
      const enlarge = gallery.querySelector('[data-machine-enlarge]');
      const count = gallery.querySelector('[data-machine-photo-count]');
      const dialog = gallery.querySelector('[data-machine-dialog]');
      const zoomed = gallery.querySelector('[data-machine-dialog-image]');
      gallery.querySelector('[data-machine-prev]').hidden = thumbnails.length < 2;
      gallery.querySelector('[data-machine-next]').hidden = thumbnails.length < 2;
      let current = 0;
      const choose = index => {
        if (!thumbnails.length) return;
        current = (index + thumbnails.length) % thumbnails.length;
        const thumb = thumbnails[current];
        main.src = thumb.dataset.image;
        main.alt = thumb.dataset.alt;
        enlarge.href = thumb.dataset.image;
        zoomed.src = thumb.dataset.image;
        zoomed.alt = thumb.dataset.alt;
        thumbnails.forEach((item, i) => item.setAttribute('aria-pressed', String(i === current)));
        count.textContent = `${current + 1} / ${thumbnails.length} photos`;
      };
      thumbnails.forEach((thumb, index) => thumb.addEventListener('click', () => choose(index)));
      enlarge.addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        zoomed.src = main.src;
        zoomed.alt = main.alt;
        dialog.showModal();
      });
      gallery.querySelector('[data-machine-close]').addEventListener('click', () => dialog.close());
      gallery.querySelector('[data-machine-prev]').addEventListener('click', () => choose(current - 1));
      gallery.querySelector('[data-machine-next]').addEventListener('click', () => choose(current + 1));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); choose(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); choose(current - 1); }
      });
    });
    collect('[data-machine-page]').forEach(page => {
      if (page.dataset.quantityReady) return;
      page.dataset.quantityReady = 'true';
      const quantity = page.querySelector('[data-machine-quantity]');
      const links = [...page.querySelectorAll('[data-machine-quote]')];
      const update = () => {
        if (!quantity.checkValidity()) return;
        links.forEach(link => { const url = new URL(link.href, location.href); url.searchParams.set('quantity', quantity.value); link.href = url.href; });
      };
      quantity.addEventListener('input', update);
      links.forEach(link => link.addEventListener('click', event => { if (!quantity.reportValidity()) event.preventDefault(); }));
      update();
    });
    collect('[data-meclean-site]').forEach(site => {
      const parameters = new URLSearchParams(location.search);
      const request = site.querySelector('[data-meclean-request-type]');
      if (request && parameters.get('intent') === 'quote-to-order') request.value = 'Quote to order';
      const quantity = site.querySelector('[data-meclean-quote-quantity]');
      const amount = parameters.get('quantity');
      if (quantity && /^\d+$/.test(amount || '')) quantity.value = String(Math.min(99, Math.max(1, Number(amount))));
      const machine = site.querySelector('[data-meclean-machine-url]');
      const relative = parameters.get('machine') || '';
      if (machine && /^\/pages\/meclean-machine-[a-z0-9-]+$/.test(relative)) machine.value = relative;
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
